const memoryCache = new Map();

const isBrowser = () => typeof window !== 'undefined';

const now = () => Date.now();

const buildStorageKey = (key) => `tq_cache_${key}`;

const readStorageEntry = (key) => {
  if (!isBrowser()) return null;

  try {
    const raw = window.localStorage.getItem(buildStorageKey(key));
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.expiresAt || parsed.expiresAt <= now()) {
      window.localStorage.removeItem(buildStorageKey(key));
      return null;
    }

    return parsed.value;
  } catch {
    return null;
  }
};

const writeStorageEntry = (key, value, ttlMs) => {
  if (!isBrowser()) return;

  try {
    window.localStorage.setItem(
      buildStorageKey(key),
      JSON.stringify({
        value,
        expiresAt: now() + ttlMs,
      })
    );
  } catch {
    // Ignore storage quota and serialization issues.
  }
};

export const getCachedValue = (key) => {
  const cached = memoryCache.get(key);
  if (cached && cached.expiresAt > now()) {
    return cached.value;
  }

  memoryCache.delete(key);

  const storageValue = readStorageEntry(key);
  if (storageValue !== null) {
    return storageValue;
  }

  return null;
};

export const setCachedValue = (key, value, ttlMs) => {
  memoryCache.set(key, {
    value,
    expiresAt: now() + ttlMs,
  });

  writeStorageEntry(key, value, ttlMs);
  return value;
};

export const invalidateCachedValue = (key) => {
  memoryCache.delete(key);

  if (!isBrowser()) return;

  try {
    window.localStorage.removeItem(buildStorageKey(key));
  } catch {
    // Ignore storage issues.
  }
};
